// eslint-disable-next-line import/prefer-default-export
export const VAT_LIST = { vatList: [0, 6, 12, 25], default: 25 };
